import { ApplicationConfig, isDevMode } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { STORE_RUNTIME_CHECKS } from './domain/store.runtime-checks';
import { provideRouterStore, routerReducer } from '@ngrx/router-store';
import { RouterStoreSerializer } from './domain/router-store.serializer';
import { STORE_EFFECTS } from './store.effects';
import { STORE_FEATURES } from './store.features';

export const StoreConfig = (): ApplicationConfig['providers'] => {
  /* Runtime checks are enabled only in development mode.
   They add extra validations to detect common NgRx mistakes such as
   mutating state or actions. Since these checks run on every state
   transition and add runtime overhead, they are disabled in production
   to keep the application performant.
  */
  const runtimeChecks = isDevMode() ? STORE_RUNTIME_CHECKS : {};
  const effects = STORE_EFFECTS.map((effect) => provideEffects(effect));

  const providers = [
    provideStore(
      {
        router: routerReducer,
      },
      { runtimeChecks },
    ),
    provideEffects([]),
    provideRouterStore({ serializer: RouterStoreSerializer }),
    ...effects,
    ...STORE_FEATURES,
  ];

  if (isDevMode()) {
    providers.push(
      provideStoreDevtools({
        maxAge: 40,
        logOnly: true,
        autoPause: true,
      }),
    );
  }
  return providers;
};
